import { render } from "./SpinnerLoader.vue?vue&type=template&id=74592b9b"
import script from "./SpinnerLoader.vue?vue&type=script&lang=js"
export * from "./SpinnerLoader.vue?vue&type=script&lang=js"

import "./SpinnerLoader.vue?vue&type=style&index=0&id=74592b9b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__